import React, { Component } from 'react';
import './Settings.css'
import Button from '@material-ui/core/Button';
import ImageIcon from '@material-ui/icons/Image';
import SaveIcon from '@material-ui/icons/Save';
import { withStyles } from '@material-ui/core/styles';
import FloatWindowLayout from './FloatWindowLayout'

const wStyles = theme => ({
    textLink:{
        height:40,
        color:"white",
        fontFamily:"Microsoft JhengHei",
        borderStyle:"soild",
        borderWidth:1,
        borderColor:"black",
        backgroundColor:"#2783c4",
        textAlign:"center",
        fontSize:20,
        lineHeight:"30px",
        margin:5,
        '&:hover':{
            color:"black",
        },
    },
    input: {
        display: "none",
    },
})

class Settings extends Component{
    constructor(props){
        super(props);
        this.state={
            imageUrl:null,
            imageAdjust:{
              contrast:100,
              hue:0,
              brightness:100,
              saturate:100,
              sepia:0,
              invert:0,
              blur:0,
              opacity:100,
            },

            originalImageSize:{
                width:null,
                height:null
            },
            dynamicImageSize:{
                width:800,
                height:800,
            },
            dynamicImageSizePer:{
                width:100,
                height:100
            },
            imageContainerPos:null,
            imageContainerSize:null,
        }

        this.refImg= React.createRef()
        this.inputRef = React.createRef()
        this.setVal = this.setVal.bind(this);
    }

    componentDidMount(){
        //console.log("Setting componentDidMount...")
        if(this.props.editImageSize)
        {
            if(this.props.loadImage)
            {
                //console.log("A")
                if(this.props.loadImage.imageUrl)
                {
                    //console.log("B")
                    this.setState({
                        imageAdjust:this.props.loadImage.imageAdjust,
                        imageUrl:this.props.loadImage.imageUrl,
                        imageContainerSize:this.props.loadImageContainerSize,
                        imageContainerPos:this.props.loadImage.imageContainerPos,
                        originalImageSize:this.props.loadImage.originalImageSize,
                        dynamicImageSize:this.props.loadImage.dynamicImageSize,  
                        dynamicImageSizePer:this.initialImageSizePer()
                    })
                }
                else
                {
                    //console.log("C")
                    this.setState({
                        imageContainerSize:this.props.loadImageContainerSize
                    })
                }
            }
            else
            {
                //console.log("D")
                this.setState({
                    imageContainerSize:this.props.loadImageContainerSize
                })
            }
        }
        else
        {
            if(this.props.loadImage.imageUrl)
            {
                //console.log("B")
                this.setState({
                    imageAdjust:this.props.loadImage.imageAdjust,
                    imageUrl:this.props.loadImage.imageUrl,
                    originalImageSize:this.props.loadImage.originalImageSize,
                    dynamicImageSize:this.props.loadImage.dynamicImageSize,  
                    dynamicImageSizePer:this.initialImageSizePer()
                    //imageContainerSize:this.props.loadImageContainerSize,
                })
            }
        }
    }

    initialImageSizePer=()=>{
        let output={
            width:Number(this.transPixToPercentage(this.props.loadImage.originalImageSize.width,this.props.loadImage.dynamicImageSize.width)),
            height:Number(this.transPixToPercentage(this.props.loadImage.originalImageSize.height,this.props.loadImage.dynamicImageSize.height))
        }
        return output
    }

    getContrast=(e)=>{
        this.setState({
            imageAdjust:{
                contrast:e.target.value,
                hue:this.state.imageAdjust.hue,
                brightness:this.state.imageAdjust.brightness,
                saturate:this.state.imageAdjust.saturate,
                sepia:this.state.imageAdjust.sepia,
                invert:this.state.imageAdjust.invert,
                blur:this.state.imageAdjust.blur,
                opacity:this.state.imageAdjust.opacity,
            }
        })
    }

    getHue=(e)=>{
        this.setState({
            imageAdjust:{
                contrast:this.state.imageAdjust.contrast,
                hue:e.target.value,
                brightness:this.state.imageAdjust.brightness,
                saturate:this.state.imageAdjust.saturate,
                sepia:this.state.imageAdjust.sepia,
                invert:this.state.imageAdjust.invert,
                blur:this.state.imageAdjust.blur,
                opacity:this.state.imageAdjust.opacity,
            }
        })
    }

    getBrightness=(e)=>{
        this.setState({
            imageAdjust:{
                contrast:this.state.imageAdjust.contrast,
                hue:this.state.imageAdjust.hue,
                brightness:e.target.value,
                saturate:this.state.imageAdjust.saturate,
                sepia:this.state.imageAdjust.sepia,
                invert:this.state.imageAdjust.invert,
                blur:this.state.imageAdjust.blur,
                opacity:this.state.imageAdjust.opacity,
            }
        })
    }

    getSaturate=(e)=>{
        this.setState({
            imageAdjust:{
                contrast:this.state.imageAdjust.contrast,
                hue:this.state.imageAdjust.hue,
                brightness:this.state.imageAdjust.brightness,
                saturate:e.target.value,
                sepia:this.state.imageAdjust.sepia,
                invert:this.state.imageAdjust.invert,
                blur:this.state.imageAdjust.blur,
                opacity:this.state.imageAdjust.opacity,
            }
        })
    }

    getSepia=(e)=>{
        this.setState({
            imageAdjust:{
                contrast:this.state.imageAdjust.contrast,
                hue:this.state.imageAdjust.hue,
                brightness:this.state.imageAdjust.brightness,
                saturate:this.state.imageAdjust.saturate,
                sepia:e.target.value,
                invert:this.state.imageAdjust.invert,
                blur:this.state.imageAdjust.blur,
                opacity:this.state.imageAdjust.opacity,
            }
        })
    }

    getInvert=(e)=>{
        this.setState({
            imageAdjust:{
                contrast:this.state.imageAdjust.contrast,
                hue:this.state.imageAdjust.hue,
                brightness:this.state.imageAdjust.brightness,
                saturate:this.state.imageAdjust.saturate,
                sepia:this.state.imageAdjust.sepia,
                invert:e.target.value,
                blur:this.state.imageAdjust.blur,
                opacity:this.state.imageAdjust.opacity,
            }
        })
    }

    getBlur=(e)=>{
        this.setState({
            imageAdjust:{
                contrast:this.state.imageAdjust.contrast,
                hue:this.state.imageAdjust.hue,
                brightness:this.state.imageAdjust.brightness,
                saturate:this.state.imageAdjust.saturate,
                sepia:this.state.imageAdjust.sepia,
                invert:this.state.imageAdjust.invert,
                blur:e.target.value,
                opacity:this.state.imageAdjust.opacity,
            }
        })
    }

    getOpacity=(e)=>{
        this.setState({
            imageAdjust:{
                contrast:this.state.imageAdjust.contrast,
                hue:this.state.imageAdjust.hue,
                brightness:this.state.imageAdjust.brightness,
                saturate:this.state.imageAdjust.saturate,
                sepia:this.state.imageAdjust.sepia,
                invert:this.state.imageAdjust.invert,
                blur:this.state.imageAdjust.blur,
                opacity:e.target.value,
            }
        })
    }

    setVal=(name,value)=>{
        switch(name){
            case 'contrast':
                return (<input type="range" step="1" min="0" max="200" onChange={this.getContrast} defaultValue={value}  />)
            case 'hue':
                return (<input type="range" step="1" min="0" max="360" onChange={this.getHue} defaultValue={value}  />)
            case 'brightness':
                return (<input type="range" step="1" min="0" max="200" onChange={this.getBrightness} defaultValue={value}  />)
            case 'saturate':
                return (<input type="range" step="1" min="0" max="100"  onChange={this.getSaturate} defaultValue={value}  />)
            case 'sepia':
                return (<input type="range" step="1" min="0" max="100" onChange={this.getSepia} defaultValue={value}  />)
            case 'invert':
                return (<input type="range" step="1" min="0" max="100"  onChange={this.getInvert} defaultValue={value}  />)
            case 'blur':
                return (<input type="range" step="1" min="0" max="10" onChange={this.getBlur} defaultValue={value}  />)
            case 'opacity':
                return (<input type="range" step="1" min="0" max="100" onChange={this.getOpacity} defaultValue={value}  />)
            default:
                return (<input type="range"/>)
        }
    }

    openFileLoadingDialog = () => {
        this.inputRef.current.click()
    }

    saveImageSettings = () => {
        let msg
        if(this.props.editImageSize)
        {
            msg = {
                imageUrl:this.state.imageUrl,
                imageAdjust:this.state.imageAdjust,
                originalImageSize:this.state.originalImageSize,
                dynamicImageSize:this.state.dynamicImageSize,
                imageContainerPos:this.state.imageContainerPos,
                imageContainerSize:this.state.imageContainerSize,
            }
        }
        else
        {
            msg = {
                imageUrl:this.state.imageUrl,
                imageAdjust:this.state.imageAdjust,
                originalImageSize:this.state.originalImageSize,
                dynamicImageSize:this.state.dynamicImageSize,
            }
        }
        this.props.saveSettings(msg)
    }

    readURL=(e)=>{
        let image = URL.createObjectURL(e.target.files[0])
        if(this.state.imageUrl !== image)
        this.setState({
            imageUrl : image
        })
    }

    getImageContainerSize=(msg)=>{
        if(this.state.imageContainerSize !== msg)
        {
            //console.log("D2")
            this.setState({
                imageContainerSize:msg
            })
        }
    }

    getDynamicImageSize=(msg)=>{

        let oWidth = 100
        let oHeight = 100
        if(this.state.originalImageSize)
        {
            //console.log("A1")
            oWidth = this.transPixToPercentage(this.state.originalImageSize.width, msg.width)
            oHeight = this.transPixToPercentage(this.state.originalImageSize.height, msg.height)
        }
        let newPer = {
            width:oWidth,
            height:oHeight
        }

        if(this.state.dynamicImageSize)
        {
            if(this.state.dynamicImageSize.width !== msg.width || this.state.dynamicImageSize.height !== msg.height)
            {
                //console.log("A2")
                this.setState({
                    dynamicImageSize:msg,
                    dynamicImageSizePer:newPer
                })
            }
            else
            {
                //console.log("A3")
            }
        }
        else
        {
            //console.log("A4")
            this.setState({
                dynamicImageSize:msg,
                dynamicImageSizePer:newPer
            })
        }
    }

    changeDynamicImageSizeByPer=(type, e)=>{
        let value= 1
        if(e.target.value < 0 || e.target.value === 0)
        {
            value = 1
        }
        else if(e.target.value > 100)
        {
            value = 100
        }
        else
        {
            value = e.target.value
        }

        if(type === "width")
        {
            if(value !== this.state.dynamicImageSizePer.width)
            {
                let pix = {
                    width:this.transPercentageToPix(value,this.state.originalImageSize.width),
                    height:this.transPercentageToPix(this.state.dynamicImageSizePer.height,this.state.originalImageSize.height)
                }
                this.setState({
                    dynamicImageSizePer:{
                        width:Number(value),
                        height:Number(this.state.dynamicImageSizePer.height)
                    },
                    dynamicImageSize:{
                        width:Number(pix.width),
                        height:Number(pix.height)
                    }
                })
            }
        }
        else if(type === "height")
        {
            if(value !== this.state.dynamicImageSizePer.height)
            {
                let pix = {
                    width:this.transPercentageToPix(this.state.dynamicImageSizePer.width,this.state.originalImageSize.width),
                    height:this.transPercentageToPix(value,this.state.originalImageSize.height)
                }
                this.setState({
                    dynamicImageSizePer:{
                        width:Number(this.state.dynamicImageSizePer.width),
                        height:Number(value)
                    },
                    dynamicImageSize:{
                        width:Number(pix.width),
                        height:Number(pix.height)
                    }
                })
            }
        }
    }

    changeDynamicImageSizeByPix=(type, e)=>{
        let value= 1
        if(type === "width")
        {
            if(e.target.value < 0 || e.target.value === 0)
            {
                value = 1
            }
            else if(e.target.value > this.state.originalImageSize.width)
            {
                value = this.state.originalImageSize.width
            }
            else
            {
                value = e.target.value
            }

            let per = {
                width:this.transPixToPercentage(this.state.originalImageSize.width,value),
                height:this.state.dynamicImageSizePer.height
            }

            if(value !== this.state.dynamicImageSize.width)
            {
                //console.log("C1")
                //console.log(value)
                //console.log(this.state.dynamicImageSize.width)
                this.setState({
                    dynamicImageSize:{
                        width:Number(value),
                        height:Number(this.state.dynamicImageSize.height)
                    },
                    dynamicImageSizePer:{
                        width:Number(per.width),
                        height:Number(per.height)
                    }
                })
            }
        }
        else if(type === "height")
        {
            if(e.target.value < 0 || e.target.value === 0)
            {
                value = 1
            }
            else if(e.target.value > this.state.originalImageSize.height)
            {
                value = this.state.originalImageSize.height
            }
            else
            {
                value = e.target.value
            }

            let per = {
                width:this.state.dynamicImageSizePer.width,
                height:this.transPixToPercentage(this.state.originalImageSize.height,value)
            }

            if(value !== this.state.dynamicImageSize.height)
            {
                this.setState({
                    dynamicImageSize:{
                        width:Number(this.state.dynamicImageSize.width),
                        height:Number(value)
                    },
                    dynamicImageSizePer:{
                        width:Number(per.width),
                        height:Number(per.height)
                    }
                })
            }
        }
    }

    transPixToPercentage=(oValue,dValue)=>{
        let output = (dValue/oValue)*100
        return output.toFixed(0)
    }

    transPercentageToPix=(per,oValue)=>{
        let output = (per/100)*oValue
        return Math.floor(output)
    }

    loadBannerSettings=()=>{
        return(
            <div className="setting">
                <label className="filterName">
                    <div>對比</div>
                    <div>{this.state.imageAdjust.contrast}</div>
                </ label>
                {this.setVal("contrast",this.state.imageAdjust.contrast)}
                <label className="filterName">
                    <div>色調</div>
                    <div>{this.state.imageAdjust.hue}</div>
                </ label>
                {this.setVal("hue",this.state.imageAdjust.hue)}
                <label className="filterName">
                    <div>亮度</div>
                    <div>{this.state.imageAdjust.brightness}</div>
                </ label>
                {this.setVal("brightness",this.state.imageAdjust.brightness)}
                <label className="filterName">
                    <div>飽和度</div>
                    <div>{this.state.imageAdjust.saturate}</div>
                </ label>
                {this.setVal("saturate",this.state.imageAdjust.saturate)}
                <label className="filterName">
                    <div>棕色調</div>
                    <div>{this.state.imageAdjust.sepia}</div>
                </ label>
                {this.setVal("sepia",this.state.imageAdjust.sepia)}
                <label className="filterName">
                    <div>正負片</div>
                    <div>{this.state.imageAdjust.invert}</div>
                </ label>
                {this.setVal("invert",this.state.imageAdjust.invert)}
                <label className="filterName">
                    <div>模糊</div>
                    <div>{this.state.imageAdjust.blur}</div>
                </ label>
                {this.setVal("blur",this.state.imageAdjust.blur)}
                <label className="filterName">
                    <div>透明度</div>
                    <div>{this.state.imageAdjust.opacity}</div>
                </ label>
                {this.setVal("opacity",this.state.imageAdjust.opacity)}
            </div>

        )
    }

    getImageSize=()=>{
        if(this.props.loadImage.imageUrl)
        {
            //console.log("A")
            if(this.state.imageUrl !== this.props.loadImage.imageUrl)
            {
                //console.log("B")
                this.setState({
                    originalImageSize:{
                        width:this.refImg.current.naturalWidth,
                        height:this.refImg.current.naturalHeight
                    },
                    dynamicImageSize:{
                        width:this.refImg.current.naturalWidth,
                        height:this.refImg.current.naturalHeight
                    },
                    dynamicImageSizePer:{
                        width:100,
                        height:100
                    }
                })
            }
            else
            {
                //console.log("C")
            }
        }
        else
        {
            //console.log("D")
            this.setState({
                originalImageSize:{
                    width:this.refImg.current.naturalWidth,
                    height:this.refImg.current.naturalHeight
                },
                dynamicImageSize:{
                    width:this.refImg.current.naturalWidth,
                    height:this.refImg.current.naturalHeight
                }
            })
        }
    }

    getFloatWindowPos=(msg)=>{
        if(this.state.imageContainerPos !== msg)
        {
            this.setState({
                imageContainerPos:msg
            })
        }
    }

    restoreWidth=()=>{
        if(this.state.dynamicImageSize.width !== this.state.originalImageSize.width)
        {
            this.setState({
                dynamicImageSize:
                {
                    width:Number(this.state.originalImageSize.width),
                    height:Number(this.state.dynamicImageSize.height)
                },
                dynamicImageSizePer:
                {
                    width:100,
                    height:Number(this.state.dynamicImageSizePer.height)
                }
            })
        }
    }

    restoreHeight=()=>{
        if(this.state.dynamicImageSize.height !== this.state.originalImageSize.height)
        {
            this.setState({
                dynamicImageSize:
                {
                    width:Number(this.state.dynamicImageSize.width),
                    height:Number(this.state.originalImageSize.height)
                },
                dynamicImageSizePer:
                {
                    width:Number(this.state.dynamicImageSizePer.width),
                    height:100
                }
            })
        }
    }

    render(){
        //console.log("Settings render...")
        //console.log(this.props.loadImageContainerSize)
        //console.log(this.props.loadImage.imageContainerPos)
        const {classes} = this.props;
        let classWithDisable = {
            pointerEvents:"none"
        }
        let imgStyle = {
            filter: ` contrast(${this.state.imageAdjust.contrast}%) hue-rotate(${this.state.imageAdjust.hue}deg) brightness(${this.state.imageAdjust.brightness}%) saturate(${this.state.imageAdjust.saturate}%) sepia(${this.state.imageAdjust.sepia}%) invert(${this.state.imageAdjust.invert}%) blur(${this.state.imageAdjust.blur}px) opacity(${this.state.imageAdjust.opacity}%)`,
            width:this.state.dynamicImageSize.width,
            height:this.state.dynamicImageSize.height,
            position: "absolute",
        }

        return(
            <div className="contentWrap">
                <div className="sidebar">
                    <input className={classes.input} type="file" ref={this.inputRef} onChange={this.readURL}/>
                    <Button className={classes.textLink} startIcon={<ImageIcon />} onClick={this.openFileLoadingDialog}>
                        開啟影像
                    </Button>
                    <Button className={classes.textLink} startIcon={<SaveIcon />} onClick={this.saveImageSettings}>
                        儲存影像
                    </Button>
                <div className="title">長寬調整</div>
                <div className="setting">
                    <label className="filterName">
                        <div>影像原始寬度</div>
                        <div>{this.state.originalImageSize? this.state.originalImageSize.width : "尚未選取影像" }</div>
                        {this.props.editImageSize ?
                        <div className={"settingRowButton"} onClick={this.restoreWidth}>還原寬度</div> 
                        :
                        null
                        }
                        
                    </label>
                    <label className="filterName">
                        <div>影像原始高度</div>
                        <div>{this.state.originalImageSize? this.state.originalImageSize.height : "尚未選取影像" }</div>
                        {this.props.editImageSize ?
                        <div className={"settingRowButton"} onClick={this.restoreHeight}>還原高度</div>
                        :
                        null
                        }
                    </label>
                </div>
                {this.props.editImageSize ? 
                <div className="setting">
                    <label className="filterName">
                        <div>影像調整寬度</div>
                        <div className="settingRow">
                            <input className={"settingRowInput"} style={this.state.dynamicImageSize? null : classWithDisable} type='number' value={this.state.dynamicImageSize? this.state.dynamicImageSize.width : "像素" } onChange={(e)=>this.changeDynamicImageSizeByPix("width",e)}/>
                            <div>{"px"}</div>
                        </div>
                        <div className="settingRow">
                            <input className={"settingRowInput"} style={this.state.dynamicImageSize? null : classWithDisable} type='number' value={this.state.dynamicImageSize ? this.state.dynamicImageSizePer.width : "百分比" } onChange={(e)=>this.changeDynamicImageSizeByPer("width",e)}/>
                            <div>{"%"}</div>
                        </div>
                    </label>
                    <label className="filterName">
                        <div>影像調整高度</div>
                        <div className="settingRow">
                            <input className={"settingRowInput"} style={this.state.dynamicImageSize? null : classWithDisable} type='number' value={this.state.dynamicImageSize ? this.state.dynamicImageSize.height : "像素" } onChange={(e)=>this.changeDynamicImageSizeByPix("height",e)}/>
                            <div>{"px"}</div>
                        </div>
                        <div className="settingRow">
                            <input className={"settingRowInput"} style={this.state.dynamicImageSize? null : classWithDisable} type='number' value={this.state.dynamicImageSize ? this.state.dynamicImageSizePer.height : "百分比"} onChange={(e)=>this.changeDynamicImageSizeByPer("height",e)}/>
                            <div>{"%"}</div>
                        </div>
                    </label>
                </div> 
                : 
                null 
                }
                
                <div className="title">濾鏡調整</div>
                    {this.loadBannerSettings()}
                </div>

                <div className="imageContainer">
                    <img  ref={this.refImg} style={imgStyle} src={this.state.imageUrl} onLoad={this.getImageSize} alt={"loadimage"}/>
                    {this.props.editImageSize ? <FloatWindowLayout imageContainerSize={this.props.loadImageContainerSize} imageContainerPos={this.props.loadImage.imageContainerPos} originalImageSize={this.state.originalImageSize} dynamicImageSize={this.state.dynamicImageSize} getImageContainerSize={this.getImageContainerSize} getDynamicImageSize={this.getDynamicImageSize} getFloatWindowPos={this.getFloatWindowPos}/> : null}
                </div>
            </div>
        )
    }
}

export default withStyles(wStyles)(Settings)